import { Divider, Stack, Typography } from "@mui/material";
import PaymentReceipt from ".";
import { PaymentMethod } from "@/services/core-api-adapter";

export default function PaymentReceiptExamples() {
  return (
    <Stack spacing={3}>
      <Stack>
        <Typography variant="h2">No discount</Typography>
        <PaymentReceipt
          amount={20000}
          currency="ZAR"
          transactionDate="2024-10-15T14:45:00+02:00"
          referenceNumber="1234567891011"
          merchantId="0000000035792468"
          cardNumber="**** **** **** 1234"
          paymentMethod={PaymentMethod.EcentricEFT}
          oneVoucherDetails={null}
          onBackButtonClick={() => console.log("Back button clicked")}
        />
      </Stack>
      <Divider />
      <Stack>
        <Typography variant="h2">With discount</Typography>
        <PaymentReceipt
          amount={20000}
          currency="ZAR"
          transactionDate="2024-10-15T14:45:00+02:00"
          referenceNumber="1234567891011"
          merchantId="0000000035792468"
          cardNumber="**** **** **** 1234"
          onBackButtonClick={() => console.log("Back button clicked")}
          isDiscountApplied
          originalAmount={30000}
          paymentMethod={PaymentMethod.EcentricEFT}
          oneVoucherDetails={null}
        />
      </Stack>
    </Stack>
  );
}
